document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('.primary-nav');
  if (toggle && nav) toggle.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav.classList.toggle('is-open', !open);
  });

  const lab = document.querySelector('[data-design-lab]');
  if (!lab) return;
  const number = (selector) => parseFloat(lab.querySelector(selector)?.value || '0');
  lab.querySelector('[data-calc-volume]')?.addEventListener('click', () => {
    const w = number('[data-volume="w"]'), h = number('[data-volume="h"]'), d = number('[data-volume="d"]'), t = number('[data-volume="t"]');
    const iw = w - 2*t, ih = h - 2*t, id = d - 2*t;
    const output = lab.querySelector('[data-volume-result]');
    if (iw <= 0 || ih <= 0 || id <= 0) output.textContent = 'Check all dimensions.';
    else output.textContent = `${(iw*ih*id/1728).toFixed(3)} ft³ gross internal volume (${iw.toFixed(2)} × ${ih.toFixed(2)} × ${id.toFixed(2)} in internal).`;
  });
  lab.querySelector('[data-calc-port]')?.addEventListener('click', () => {
    const vFt = number('[data-port="v"]'), f = number('[data-port="f"]'), dIn = number('[data-port="d"]'), n = number('[data-port="n"]');
    const output = lab.querySelector('[data-port-result]');
    if (vFt <= 0 || f <= 0 || dIn <= 0 || n < 1) return output.textContent = 'Check all design targets.';
    const vL = vFt * 28.3168, dCm = dIn * 2.54;
    const lengthCm = (23562.5 * dCm*dCm*n)/(f*f*vL) - (0.732*dCm);
    output.textContent = lengthCm > 0 ? `${(lengthCm/2.54).toFixed(2)} in estimated length per port.` : 'Those targets do not produce a practical positive port length.';
  });
  lab.querySelector('[data-calc-wire]')?.addEventListener('click', () => {
    const z = number('[data-wire="z"]'), c = number('[data-wire="c"]'), s = number('[data-wire="s"]');
    const mode = lab.querySelector('[data-wire="mode"]')?.value;
    const output = lab.querySelector('[data-wire-result]');
    if (z <= 0 || c < 1 || s < 1) return output.textContent = 'Check speaker configuration.';
    const total = mode === 'series' ? z*c*s : z/(c*s);
    output.textContent = `${total.toFixed(2)} Ω estimated final load when every coil and subwoofer is wired ${mode}.`;
  });
});
